import { EntityState, StoreConfig, EntityUIStore } from '@datorama/akita';
import { UserNotification } from './user-notification';
import { Injectable, OnDestroy } from '@angular/core';
import { NotificationsQuery } from './notifications.query';
import { AbstractEntityStore } from './abstract-entity.store';

export interface RecentNotificationsState extends EntityState<UserNotification, number> {
}

@Injectable({
    providedIn: 'root'
})
@StoreConfig({ name: 'recentNotifications' })
export class RecentNotificationsStore extends AbstractEntityStore<RecentNotificationsState> implements OnDestroy {
    constructor(
        protected notificationsQuery: NotificationsQuery
    ) {
        super()

        this.syncToQueryUpdates(this.notificationsQuery)
    }
}